
import {defineComponent} from 'vue';
import AutocompleteOption from '@ohrm/oxd/core/components/Input/Autocomplete/AutocompleteOption.vue';
import usei18n from '../../../../composables/usei18n';

export default defineComponent({
  name: 'oxd-autocomplete-dropdown',

  components: {
    'oxd-autocomplete-option': AutocompleteOption,
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    empty: {
      type: Boolean,
      default: false,
    },
  },

  setup() {
    return {
      ...usei18n(),
    };
  },
});
